var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F88962"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20170_44321",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20170_44321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62843 15.9102H19.9334C20.2451 15.9102 20.5001 16.1652 20.5001 16.4768V17.6102C20.5001 17.9218 20.2451 18.1768 19.9334 18.1768H8.62843C8.31677 18.1768 8.06177 17.9218 8.06177 17.6102V16.4768C8.06177 16.1652 8.31677 15.9102 8.62843 15.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 18.1768H4.06667C3.755 18.1768 3.5 17.9218 3.5 17.6102V16.4768C3.5 16.1652 3.755 15.9102 4.06667 15.9102H5.2C5.51167 15.9102 5.76667 16.1652 5.76667 16.4768V17.6102C5.795 17.8935 5.56833 18.1485 5.25667 18.1768C5.22833 18.1768 5.2 18.1768 5.2 18.1768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 13.105H4.06667C3.755 13.105 3.5 12.85 3.5 12.5384V11.405C3.5 11.0934 3.755 10.8384 4.06667 10.8384H5.2C5.51167 10.8384 5.76667 11.0934 5.76667 11.405V12.5384C5.795 12.8217 5.56833 13.0767 5.25667 13.105C5.22833 13.105 5.2 13.105 5.2 13.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 8.03327H4.06667C3.755 8.03327 3.5 7.77827 3.5 7.4666V6.33327C3.5 6.0216 3.755 5.7666 4.06667 5.7666H5.2C5.51167 5.7666 5.76667 6.0216 5.76667 6.33327V7.4666C5.795 7.74994 5.56833 8.00494 5.25667 8.03327C5.22833 8.03327 5.2 8.03327 5.2 8.03327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62843 10.8384H18.5734C18.8851 10.8384 19.1401 11.0934 19.1401 11.405V12.5384C19.1401 12.85 18.8851 13.105 18.5734 13.105H8.62843C8.31677 13.105 8.06177 12.85 8.06177 12.5384V11.405C8.06177 11.0934 8.31677 10.8384 8.62843 10.8384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62843 5.79492H19.9334C20.2451 5.79492 20.5001 6.04992 20.5001 6.36159V7.49492C20.5001 7.80659 20.2451 8.06159 19.9334 8.06159H8.62843C8.31677 8.06159 8.06177 7.80659 8.06177 7.49492V6.36159C8.06177 6.04992 8.31677 5.79492 8.62843 5.79492Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.d7ce073d7b3b551dbc77ce3441ac500c.svg";
export { ForwardRef as ReactComponent };